import React, { FC } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from '../../../../../common/components/PruRoute';
import AdbuTargetListingPage from './List/AdbuTargetListingPage';
import AdbuTargetReportPage from './Create/AdbuTargetReportPage';
import ParamsProvider from '../../../../../common/components/ParamsProvider';
import { reportFilterKeys } from '../../../constants';

const AdbuTargetPage: FC<RouteComponentProps> = ({ history, location, match }) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`}/>
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={reportFilterKeys}>
            <AdbuTargetListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute
        exact
        path={`${match.path}/create`}
        component={AdbuTargetReportPage}
      />
    </Switch>
  )
};

export default AdbuTargetPage;
